import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { useState } from "react";
import { handleApiError } from "@/utils/errors";
import { catchError } from "@/lib/errors";
import { toast } from "sonner";
import { alertsRepo } from "@/lib/repositories";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";
import { queryClient } from "@/lib/query-client";
import DotPattern from "@/components/dot-pattern";
import AlertForm from "@/features/alerts/components/forms/alert-form";
import { alertFormSchema } from "@/features/alerts/components/forms/schemas";

const AlertCreatePage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof alertFormSchema>>({
    resolver: zodResolver(alertFormSchema),
    defaultValues: {
      frequency: "immediate",
      send_email: false,
      alert_type: "new_dilemma",
      dilemma: undefined,
      title: "",
      message: "",
      is_active: true,
    },
  });

  async function onSubmit(data: z.infer<typeof alertFormSchema>) {
    setIsLoading(true);
    const payload = {
      ...data,
      send_push: true,
      dilemma: data.alert_type === "focus_dilemma" ? data.dilemma : undefined,
    };
    const [error] = await catchError(alertsRepo.create(payload));
    if (error) {
      toast.error(handleApiError(error).message);
      setIsLoading(false);
      return;
    }
    await queryClient.invalidateQueries({ queryKey: ["alerts"] });
    toast.success(t("messages.alert_create_success"));
    navigate(ROUTES.WARNINGS);
    setIsLoading(false);
  }

  return (
    <div className="relative h-full flex flex-col items-center gap-y-3 p-3 py-4 sm:py-10 sm:p-6">
      <DotPattern />
      <AlertForm form={form} onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  );
};

export default AlertCreatePage;
